module.exports = __webpack_public_path__ + "static/media/doors.f649da87.png";